// components/PhoneNumberInput.js
import React, { useState } from "react";
import axios from "axios";
import { toast } from 'react-toastify'; // Import toast from react-toastify
import 'react-toastify/dist/ReactToastify.css'; // Import toast CSS
const apiBase = process.env.REACT_APP_API;

const PhoneNumberInput = ({ setPhoneNumber, setEmail }) => {
  const [phone, setPhone] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSendOtp = async () => {
    setIsLoading(true);
    try {
      const response = await axios.post(`${apiBase}/reset-password/otp`, {
        phone_number: phone,
      });
      const { message, email } = response.data;
      toast.success(message);
  
      // Set the phone number and email
      setPhoneNumber(phone);
      setEmail(email);

    
    } catch (error) {
      setError(error.response?.data?.message || "Failed to send OTP");
    }finally{
        setIsLoading(false);
    }
  };


  return (
    <div className="bg-white p-6 rounded shadow-lg w-80">
      <h2 className="text-2xl font-bold mb-4">Reset Your Password</h2>
      <p className="text-gray-600 mb-4">
        An email will be sent to your email address with an OTP.
      </p>
      <input
        type="text"
        placeholder="Enter your phone number"
        value={phone}
        onChange={(e) => setPhone(e.target.value)}
        className="w-full p-2 border border-gray-300 rounded mb-4"
        disabled={isLoading}
      />
      <button
        onClick={handleSendOtp}
        className={`w-full p-2 rounded text-white ${isLoading ? "bg-gray-400" : "bg-blue-500 hover:bg-blue-600"}`}
        disabled={isLoading}
      >
        {isLoading ? (
          <div className="flex items-center justify-center">
            <svg
              className="animate-spin h-5 w-5 mr-2 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              ></circle>
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
              ></path>
            </svg>
            Sending...
          </div>
        ) : (
          "Send OTP"
        )}
      </button>
      {error && <p className="text-red-500 mt-2">{error}</p>}
    </div>
  );



};

export default PhoneNumberInput;
